import React, { Component } from "react";
import { formatAmount } from "../lib/payment-utils";

/**
 * Renders the shopping cart component. Its a wrapper which 
 * containes two components shopping cart billing summary
 * and shopping cart payment component. 
 * expected properties:
 *  idx
 *  payment
 *  state
 *  config
 */
class ShoppingCartPaymentWrapper extends Component {
  render() {
    const { config, payment, idx, state, appComponents } = this.props,
    {ShoppingCartBillSummary,ShoppingCartPaymentItems} = appComponents,
      { messages, channelCode } = config;
    if (payment.header.paymentTypeCode === "UNLISTED") {
      return null;
    }
    return (
      <div className="payment-info-container">
        <div className="row">
          <ShoppingCartBillSummary
            key={"ShoppingCartBillSummary"}
            idx={idx}
            config={config}
            payment={payment}
            state={state}
          />
          <ShoppingCartPaymentItems
            key={"ShoppingCartPaymentItems"}
            idx={idx}
            config={config}
            payment={payment}
            state={state}
          />
        </div>
      </div>
    );
  }
}

export default ShoppingCartPaymentWrapper;
